<template>
  <div class="user-page">
    <div class="features f-r-vc">
      <el-button
        type="primary"
        class="feature-button depp-green-bg"
        @click="openUserDialog(null)"
      >
        <svg-icon icon-class="plus" class="svg-white-color" />
        Create User
      </el-button>
    </div>
    <div class="user-list">
      <searchable-table
        v-loading="loadingTable"
        :table-headers="UserTableHeaders"
        :table-data="userQuery"
        :search-params="searchForm"
        :search-param-change="searchParamChange"
        :has-actions="true"
      >
        <template v-slot:actions>
          <div class="buttons f-r">
            <el-button size="small" type="text"> Edit </el-button>
            <el-button size="small" type="text"> Delete </el-button>
            <el-button size="small" type="text"> Roles </el-button>
          </div>
        </template>
      </searchable-table>
    </div>
    <dialog-edit-or-create ref="userEdit" :formInputInit="InitUserForm" />
  </div>
</template>
<script>
import set from 'lodash/set'
import cloneDeep from 'lodash/cloneDeep'
// apis
import { queryUser, createUser, updateUser, removeUser } from '@/api/user'
// models
import {
  UserTableHeaders,
  UserSearchForm,
  InitUserForm,
  UserSearchParamsWrapUp
} from '@/core/models/user'
// components
import DialogEditOrCreate from '@/components/common/DialogEditOrCreate.vue'
import SearchableTable from '@/components/common/SearchableTable.vue'
export default {
  name: 'RoleView',
  components: {
    SearchableTable,
    DialogEditOrCreate
  },
  data() {
    return {
      UserTableHeaders,
      UserSearchForm,
      searchForm: cloneDeep(UserSearchForm),
      loadingTable: false,
      userQuery: null
    }
  },
  mounted() {
    this.doSearch()
  },
  methods: {
    InitUserForm,
    searchParamChange(key, path, value) {
      set(this.searchForm[key], path, value)
      this.doSearch()
    },
    createUserCb(data) {
      data.clientId = 'warehouse'
      createUser(data).then(res => {
        if (res) {
          this.$message.success('Create user successfully!')
          this.doSearch()
        }
      })
    },
    updateUserCb(data) {
      updateUser(data).then(res => {
        if (res) {
          this.$message.success('Update user successfully!')
          this.doSearch()
        }
      })
    },
    deleteUser(data) {
      this.$confirm(`Delete user ${data.username}, continue?`, 'Confirm', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          removeUser(data.id).then(res => {
            if (res) {
              this.$message.success('Delete successfully!!')
              this.doSearch()
            }
          })
        })
        .catch(() => {})
    },
    openUserDialog(data) {
      this.$refs.userEdit.open(
        data,
        data ? this.updateUserCb : this.createUserCb
      )
    },
    doSearch() {
      const params = UserSearchParamsWrapUp(this.searchForm)
      this.loadingTable = true
      queryUser(params).then(res => {
        this.loadingTable = false
        this.userQuery = res
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.user-page {
  width: 100%;
  overflow-x: hidden;

  .features {
    @extend .global-margin;
  }

  @extend .f-c;

  .user-list {
    @extend .global-margin;
    @extend .shadow-level-three;

    border-radius: $home-card-border-radius;
    padding: $home-card-padding-y $home-card-padding-x;
    background-color: white;
  }
}

.buttons {
  flex-wrap: wrap;
  gap: 5px;

  .el-button {
    margin: 0 !important;
  }
}
</style>
